import { workerProfileAttributes } from "@clipboard-health/contract-worker-app-bff";
import { patch } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { type Worker } from "@src/appV2/Worker/api/types";
import { useGetWorker } from "@src/appV2/Worker/api/useGetWorker";
import { useMutation, type UseMutationOptions } from "@tanstack/react-query";

const SIGN_IC_AGREEMENT_URL = `${environmentConfig.REACT_APP_WORKER_SERVICE_URL}/agentprofile/signContractorAgreement`;

export function useSignICAgreement(
  options: UseMutationOptions<
    Pick<Worker, "signedContractorAgreements">,
    Error,
    {
      workerId: string;
      agreementVersion: number;
      signature: string;
      forceReSignAgreement?: boolean;
    }
  >
) {
  const { refetch: refetchWorker } = useGetWorker({
    enabled: false,
  });

  return useMutation({
    mutationKey: ["sign-ic-agreement"] as const,
    mutationFn: async (params: {
      workerId: string;
      agreementVersion: number;
      signature: string;
      forceReSignAgreement?: boolean;
    }) => {
      const { workerId, agreementVersion, signature, forceReSignAgreement } = params;

      const response = await patch({
        url: SIGN_IC_AGREEMENT_URL,
        data: {
          agentId: workerId,
          agreementVersion: `V${agreementVersion}`,
          signature,
          forceReSignAgreement,
        },
        responseSchema: workerProfileAttributes.pick({ signedContractorAgreements: true }),
      });

      await refetchWorker();

      return response.data;
    },
    ...options,
  });
}
